import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';
import CardAdhesion from '../../components/Carousel/CardAdhesion';
// import MainContainerAdhesion2 from '../../components/Carousel/MainContainerAdhesion2'; // décommenter si utilisé

const colors = {
  bg: '#FFFFFF',
  goldLight: '#F5E1C8',
  gold: '#C69C6D',
  text: '#3B2F2A',
};

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const Fidelity = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .fidelity-page {
          background: ${colors.bg};
          position: relative;
          min-height: 100vh;
          overflow: hidden;
        }

        /* Orbes dorées décoratives */
        .fidelity-page::before,
        .fidelity-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.2;
          z-index: 0;
          pointer-events: none;
        }

        .fidelity-page::before {
          width: 50vw;
          height: 50vw;
          background: ${colors.goldLight};
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .fidelity-page::after {
          width: 40vw;
          height: 40vw;
          background: #EAD5C0;
          bottom: -8%;
          right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .content-wrapper {
          position: relative;
          z-index: 1;
          padding-top: 80px; /* hauteur du header */
          padding-bottom: 60px;
          max-width: 1400px;
          margin: 0 auto;
          padding-left: 20px;
          padding-right: 20px;
        }

        /* Titre */
        .page-title {
          font-size: clamp(2.2rem, 5vw, 3rem);
          font-weight: 700;
          color: ${colors.text};
          text-align: center;
          margin-bottom: 0.5rem;
          letter-spacing: -0.5px;
        }

        .title-underline {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${colors.gold}, #B88A56);
          margin: 10px auto 50px;
          border-radius: 2px;
        }

        @media (max-width: 768px) {
          .content-wrapper {
            padding-top: 70px;
            padding-left: 16px;
            padding-right: 16px;
          }
        }
      `}</style>


      <Header />

      <motion.div
        className="fidelity-page"
        variants={pageVariants}
        initial="initial"
        animate="animate"
      >
        <div className="content-wrapper">
        
          <motion.div
            className="title-underline"
            initial={{ width: 0 }}
            animate={{ width: 80 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          />

          {/* Les composants existants, à remplacer plus tard par leur version modernisée */}
          <CardAdhesion />
          {/* <MainContainerAdhesion2 /> */}
        </div>
      </motion.div>

      <Footer />
    </>
  );
};

export default Fidelity;